<script setup lang="ts">
defineProps<{
  gap?: string;
  divider?: boolean;
}>();
</script>

<template>
  <div
    class="split-layout"
    :style="{ gap }">
    <div class="split-layout__left">
      <slot name="left">Left</slot>
    </div>
    <div
      class="divider"
      v-if="divider" />
    <div class="split-layout__right">
      <slot name="right">Right</slot>
    </div>
  </div>
</template>

<style scoped>
@media (min-width: 34rem) {
  .split-layout {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    grid-template-areas: 'left divider right';
    gap: var(--size-2);

    height: 100%;
    width: 100%;
  }

  .split-layout__left {
    grid-area: left;
  }

  .divider {
    grid-area: divider;
    height: 100%;
    width: 1px;
    border: 1px solid rgb(var(--brand-600));
  }

  .split-layout__right {
    grid-area: right;
  }
}
</style>
